// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2315":"56ef92d6","4295":"d8123c02","6370":"edc44606","7745":"edc44606"}[chunkId] + ".chunk.css";
};